import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';

const firebaseRef = firebase.database();

export async function checkDepositSchedule(leadId, callback) {
	await firebaseRef
		.ref(
			'/kavtek_agreements/' +
				PROJECT_CODE.projectCode +
				'/' +
				leadId +
				'/depositSchedule'
		)
		.once('value', (snapshot) => {
			var depositScheduleObj = snapshot.val();

			if (depositScheduleObj) {
				callback(true);
			} else {
				callback(false);
			}
		});
}
